import { render, staticRenderFns } from "./SingleCompanyGroups.vue?vue&type=template&id=71cbed7a&scoped=true&"
import script from "./SingleCompanyGroups.vue?vue&type=script&setup=true&lang=js&"
export * from "./SingleCompanyGroups.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SingleCompanyGroups.vue?vue&type=style&index=0&id=71cbed7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cbed7a",
  null
  
)

export default component.exports